<template>
  <div class="conuslt-index-avator-video">
    <van-popup
      v-model="show"
      :close-on-click-overlay="false"
      @click-overlay="$emit('close')"
    >
      <div class="video-box">
        <xgPlayer
          v-if="xgVideoConfig"
          class="consult-video"
          ref="xgPlayer"
          :config="xgVideoConfig"
          @playing="_onVideoPlaying"
          @firstPlay="_onVideoFirstPlay"
          @pause="isPlay = false"
          @onPlay="isPlay = true"
        />
      </div>
      <div class="action-field">
        <div class="click-video-btn" @click="handlePlay">
          <img
            src="~images/platform/homepage/ic-purse.png"
            alt=""
            class="purse-btn"
            v-if="isPlay"
          />
          <img
            src="~images/platform/homepage/play.png"
            alt=""
            class="purse-btn"
            v-else
          />
        </div>
        <div class="process-container">
          <processBar
            v-if="duration"
            :currentTime="currentTime"
            :duration="duration"
            :isProcessDraging="isProcessDraging"
            @_onProgressDrag="_onProgressDrag"
            @processBarTouchStart="processBarTouchStart"
            @processBarTouchEnd="processBarTouchEnd"
          />
        </div>
      </div>
    </van-popup>
    <div class="close-btn" v-if="show" @click="$emit('close')">关闭</div>
  </div>
</template>
<script>
import xgPlayer from 'component/platform/xgPlayer/index.vue'
import processBar from 'component/platform/xgPlayer/processBar.vue'
import { Popup } from 'vant'
export default {
  props: {
    show: {
      type: Boolean,
      default: false
    },
    videoInfo: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    xgPlayer,
    processBar,
    [Popup.name]: Popup
  },
  data() {
    return {
      currentTime: 0,
      hasFirstPlay: false,
      isProcessDraging: false,
      isPlay: true
    }
  },
  mounted() {},
  methods: {
    // 进度条-开始拖拽
    processBarTouchStart() {
      if (!this.hasFirstPlay) {
        return
      }
      this.isProcessDraging = true
    },
    // 进度条-正在拖拽
    _onProgressDrag(ct) {
      if (!this.hasFirstPlay) {
        return
      }
      this.$refs.xgPlayer.changeCT(+ct)
    },
    // 进度条-停止拖拽
    processBarTouchEnd() {
      if (!this.hasFirstPlay) {
        return
      }
      this.isProcessDraging = false
    },
    // 视频播放中
    _onVideoPlaying(currentTime) {
      const { video_duration } = this.videoInfo
      this.currentTime =
        +currentTime <= +video_duration ? +currentTime : +video_duration
    },
    // 首次播放
    _onVideoFirstPlay() {
      this.hasFirstPlay = true
    },
    // 暂停播放
    handlePlay() {
      this.isPlay = !this.isPlay
      if (this.isPlay) {
        this.$refs.xgPlayer.playVideo()
      } else {
        this.$refs.xgPlayer.purseVideo()
      }
    }
  },
  computed: {
    xgVideoConfig() {
      if (!this.$isServer && this.videoInfo) {
        const { video_cover, video_m3u8, video_url } = this.videoInfo
        return {
          width: '100%',
          height: '100%',
          id: 'xgplayer',
          url: video_m3u8 || video_url || '',
          // url: 'https://videocdn.xinli001.com/m3u8/operate_videos/consult_talk/2022228/1646036949997lFc1uYbv2C4QmvTO88yy5OWeNAksC1Yq.m3u8',
          // url: 'https://videocdn.xinli001.com/shortVideos/20211230/1640835405241ET5Zs4s6N3k5bnxVNeWqfxSYVJAcx4tF.mp4?w=320&h=568',
          poster: video_cover || '',
          playsinline: this.$platform.isAndroid ? false : true,
          videoInit: true,
          errorTips: `请<span>刷新</span>试试`,
          'x5-video-player-type': 'h5-page',
          autoplay: true
        }
      }
      return null
    },
    duration() {
      if (this.videoInfo && this.videoInfo.video_duration) {
        return +this.videoInfo.video_duration
      } else {
        return 0
      }
    }
  },
  watch: {
    show(val) {
      if (!val) {
        this.$refs.xgPlayer.purseVideo()
      } else {
        this.$refs.xgPlayer.playVideo()
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.conuslt-index-avator-video {
  ::v-deep .video-box {
    width: 10rem;
  }
  ::v-deep .van-overlay {
    background-color: rgba(0, 0, 0, 1);
  }
  .close-btn {
    font-size: 28px;
    color: #fff;
    position: fixed;
    top: 60px;
    right: 20px;
    z-index: 9999;
    padding: 20px;
  }
}
.action-field {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 750px;
  padding: 0 30px;
  box-sizing: border-box;
  display: flex;
  align-items: flex-start;
  .click-video-btn {
    width: 50px;
    height: 50px;
    position: relative;
    bottom: 24px;
    padding-right: 10px;
    .purse-btn {
      width: 50px;
      height: 50px;
    }
  }
  .process-container {
    height: 50px;
    flex: 1;
    position: relative;
  }
}
.common-model-up-outer {
  z-index: 999 !important;
}
</style>
